<template>
  <div class="prize-container">
    <div class="prize-box">
      <div class="prize-list" v-if="loaded">
        <div class="prize-item" v-for="(item, index) in prizeList" :key="index">
          <img class="item-img" :src="item.h_img" alt="" />
          <div class="item-text">{{ item.card_name }} x 1</div>
          <div class="item-btn" v-if="item.flag == 2" @click="useVoucher">
            去使用
          </div>
          <div class="item-btn btn-disabeld" v-else>已失效</div>
        </div>
        <div class="not-prize" v-if="!prizeList.length">暂无奖品</div>
      </div>
    </div>
    <!-- logo -->
    <div class="logo-container">
      <img
        class="logo-item"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/24da8650c5efff164cc4fb70e8d11805.png"
        alt=""
      />
      <div class="line"></div>
      <img
        class="logo-item"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/pub-jzy-logo"
        alt=""
      />
    </div>
    <van-loading
      v-if="!loaded"
      class="loading"
      type="spinner"
      color="#f96d91"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      loaded: false,
      prizeList: [],
      miniprogramAppId: 'wxef4ebc9dd6e4030d', //小程序appid
      miniprogramOid: 'gh_a0874cf4204c', //小程序原始id
      miniprogramPath: 'pages/tabbar/user/center' //小程序路径
    }
  },
  filters: {
    formatStatus(status) {
      let str = status == 2 ? '去使用' : '已失效'
      return
    }
  },
  created() {
    this.getPrizeList()
  },
  methods: {
    //新版数据统计
    addLog() {
      let data = {
        from: '2022年女神节「去兑换」按钮点击量',
        type: 3
      }
      this.$http
        .postApp('member/StorageLogin/spotLog', data)
        .then((res) => {})
        .catch((err) => {})
    },
    //使用兑换券
    useVoucher() {
      this.addLog()
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageRoute({
          path: 'miniProgram', //跳转页面路径
          //跳转所需参数
          params: [
            { key: 'userName', value: this.miniprogramOid },
            { key: 'path', value: this.miniprogramPath }
          ]
        })
        return
      }
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          // 当前是微信小程序环境
          let data = {
            appid: this.miniprogramAppId,
            path: this.miniprogramPath
          }
          data.path = data.path ? encodeURIComponent(data.path) : data.path
          wx.miniProgram.navigateTo({
            url:
              '/pages/navigateToOtherMiniProgram/index?data=' +
              JSON.stringify(data)
          })
        }
      })
    },
    getPrizeList() {
      this.$http
        .getApp('member/ActivityGirl/myGiftList', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.prizeList = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
          this.$toast('异常错误')
        })
        .finally(() => {
          this.loaded = true
        })
    }
  }
}
</script>
<style scoped lang="scss">
.prize-container {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022_goddess_festival_my_prize_bg');
  background-size: contain;
  background-position: center top;
  background-repeat: no-repeat;
  background-color: #fed7ed;
}
.prize-box {
  margin-top: 216px;
  padding: 0px 17px;
  box-sizing: border-box;
}
.prize-list {
  padding: 16px 18px 16px 20px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 13px;
  .prize-item {
    display: flex;
    align-items: center;
    padding: 10px 0px;
    box-sizing: border-box;
    border-bottom: 1px solid #f7f7f7;
    .item-img {
      width: 44px;
      margin-right: 10px;
    }
    .item-text {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      margin-right: 10px;
    }
    .item-btn {
      text-align: center;
      width: 73px;
      height: 24px;
      background: #fff5dc;
      border-radius: 6px;
      border: 1px solid #e8d8c1;
      font-size: 12px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #383d48;
      line-height: 24px;
      box-sizing: border-box;
    }
    .btn-disabeld {
      background-color: rgba(0, 0, 0, 0.5);
      color: #fff;
      border: none;
    }
  }
}
.logo-container {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 43px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 31px;
  .logo-item {
    width: auto;
    height: 27px;
  }
  .line {
    width: 1px;
    height: 27px;
    background: rgba(0, 0, 0, 0.24);
    margin: 0px 10px;
  }
}
.not-prize {
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  margin: 60px 0px;
}
.loading {
  position: fixed;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
</style>
